import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-shop-feature-list-item',
    templateUrl: './checkout-feature-list-item.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./checkout-feature-list-item.component.scss'],

})
export class CheckoutFeatureListItemComponent {

}
